import { fetchApi } from '@/services/api-client';

export const SCHEDULE_VARIANTS_PATH = '/admin/timetable/schedule-variants';

export type VariantSlotKind = 'lesson' | 'break' | 'activity';

export type VariantSlot = {
  id: string;
  periodId: string | null;
  name: string;
  startTime: string;
  endTime: string;
  kind: VariantSlotKind;
  sortOrder: number;
};

export type SlotInput = Omit<VariantSlot, 'id'>;

export type ScheduleVariant = {
  id: string;
  name: string;
  active: boolean;
  slots: VariantSlot[];
};

export const scheduleVariantsApi = {
  list: () => fetchApi<ScheduleVariant[]>(SCHEDULE_VARIANTS_PATH),
  get: (id: string) => fetchApi<ScheduleVariant>(`${SCHEDULE_VARIANTS_PATH}/${id}`),
  create: (data: { name: string; fromDefault?: boolean }) =>
    fetchApi<ScheduleVariant>(SCHEDULE_VARIANTS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: { name?: string; active?: boolean }) =>
    fetchApi<ScheduleVariant>(`${SCHEDULE_VARIANTS_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  replaceSlots: (id: string, slots: SlotInput[]) =>
    fetchApi<ScheduleVariant>(`${SCHEDULE_VARIANTS_PATH}/${id}/slots`, {
      method: 'PUT',
      body: JSON.stringify({ slots }),
    }),
  remove: (id: string) => fetchApi<{ success: boolean }>(`${SCHEDULE_VARIANTS_PATH}/${id}`, { method: 'DELETE' }),
};
